import { render, staticRenderFns } from "./PageUsers.vue?vue&type=template&id=6fd2270a&scoped=true&"
import script from "./PageUsers.vue?vue&type=script&lang=js&"
export * from "./PageUsers.vue?vue&type=script&lang=js&"
import style0 from "./PageUsers.vue?vue&type=style&index=0&id=6fd2270a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd2270a",
  null
  
)

export default component.exports